export const USER_CLEAR_DATA = "login/USER_CLEAR_DATA";
